module.exports = "/images/vessel-3.jpg";